import Service from '../restService'
import ChsLoginService from './chsLoginService'
import ChsDeviceService from './chsDeviceService';

class ChirpstackServices extends Service {
    constructor(storage, errorHandler) {
        super(storage, (() => ''), (() => ''), errorHandler);

        this.getUrl = () => this.storage.getItem('chirpstack/state', 'site');
        this.getUrlCbk = () => this.storage.getItem('chirpstack/state', 'site') + '/api/';
        this.getAuthCbk = () => this.storage.getItem('chirpstack/auth', 'jwt');
        this.errorHandler = errorHandler;

        this.getRoutes = () => {
            return ({
                home: process.env.REACT_APP_CHIRPSTACK_UI_URL || this.getUrl(),
            });
        }

        this.services = {
            routes: this.getRoutes,
            login: new ChsLoginService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            device: new ChsDeviceService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
        }

    }
    getServices = () => this.services;

    setUpdateStateCbk = (callback) => {
        this.updateState = callback;
        this.services.login.setUpdateStateCbk(this.updateState);
    }
}

export default ChirpstackServices;